import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Tooltip } from '@mui/material'

export const displayToggleOptions = [
  {
    value: true,
    icon: (
      <Tooltip title='Apply'>
        <CheckCircleOutlineIcon />
      </Tooltip>
    ),
  },
  {
    value: false,
    icon: (
      <Tooltip title='Skip'>
        <BlockOutlinedIcon />
      </Tooltip>
    ),
  },
]
